import React, {useState} from 'react';
import PropTypes from "prop-types";
import {contentUtils, HTMLContent} from "mindsets-js-sdk";

import './number_only.scss';

import NumberOnlyField from './NumberOnlyField';

function NumberOnly(
    {
        component_data,
        correct_answer,
        onCorrectAnswerChange
    }
) {
    const [answer, setAnswer] = useState(!!correct_answer && !Array.isArray(correct_answer) ? correct_answer : defaultAnswer());

    function defaultAnswer() {
        const items = _.get(component_data, 'data.items');
        const inputItems = _.filter(items, {type: 'input'});
        const answer_selections = _.fill(Array(inputItems.length), '');

        return {
            text: '',
            answer_selections
        }
    }

    function onChange(inputKey) {
        return e => {
            e.preventDefault();
            const regex = /^[0-9.+-]*$/;
            const v = e.target.value;
            if (v.match(regex)) {
                const newAnswerSelections = _.clone(answer.answer_selections);
                _.set(newAnswerSelections, inputKey, v);
                const newText = getAnswerText(newAnswerSelections);
                const newAnswer = {
                    text: newText,
                    answer_selections: newAnswerSelections
                }
                if (newAnswer.text) {
                    onCorrectAnswerChange(newAnswer);
                } else {
                    onCorrectAnswerChange(null);
                }
                setAnswer(newAnswer);
            }
        }
    }

    function getAnswerText(answer_selections) {
        const isNotEmpty = !!_.find(answer_selections, (v) => !!v);
        if (!isNotEmpty) {
            return '';
        }

        const items = _.get(component_data, 'data.items', []);
        let inputKey = -1;
        const textArray = items.map((item) => {
            if (item.type === 'input') {
                inputKey++;
                return _.get(answer_selections, inputKey, '');
            } else {
                return _.get(item, 'content.text');
            }
        })
        return textArray.join('');
    }

    function renderItem(itemData, inputKey) {
        switch (itemData.type) {
            case 'hidden':
                return null;
            case 'static':
                const content = _.get(itemData, 'content.html');
                return (
                    <div className="cc-numberonly-item-static" style={itemData.style}>
                        <HTMLContent html_str={contentUtils.processStringContent(content)}/>
                    </div>
                );
            case 'input':
                return (
                    <NumberOnlyField
                        component_data={component_data}
                        answer={answer}
                        existing_answer={correct_answer}
                        onChange={onChange(inputKey)}
                        itemData={itemData}
                        inputKey={inputKey}
                    />
                );
            default:
                return null;
        }
    }

    function renderAllItems() {
        const items = _.get(component_data, 'data.items', []);
        let inputKey = -1;
        return items.map((itemData, itemKey) => {
            if (itemData.type === 'input') {
                inputKey++;
            }
            return (
                <div key={itemKey}>
                    {renderItem(itemData, inputKey)}
                </div>
            );
        });
    }

    return (
        <div className="challenge-component-numberonly">
            <div className="cc-numberonly-description">
                {`Enter a number in each box below.`}
            </div>

            <div className="d-flex flex-wrap align-items-center">
                {renderAllItems()}
            </div>
        </div>
    );
}

NumberOnly.propTypes = {
    component_data: PropTypes.object.isRequired,
    correct_answer: PropTypes.oneOfType([
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            answer_selections: PropTypes.array.isRequired
        }),
        PropTypes.array
    ]),
    onCorrectAnswerChange: PropTypes.func.isRequired
}

export default NumberOnly;
